<template>
  <tr>
    <td>{{ item.created_at }}</td>
    <td>{{ item.operation }}</td>
    <td>{{ item.method }}</td>
    <td>{{ item.payway }}</td>
    <td>
      <div style="display: flex; align-items: center; gap: 8px">
        {{ shortWord(item.payment_transaction_id) }}
        <v-icon
          v-if="item.payment_transaction_id"
          style="cursor: pointer"
          small
          @click="copyID(item.payment_transaction_id)"
        >
          content_copy
        </v-icon>
      </div>
    </td>
    <td>
      <div style="display: flex; align-items: center; gap: 8px">
        {{ shortWord(item.outer_transaction_id) }}
        <v-icon
          v-if="item.outer_transaction_id"
          style="cursor: pointer"
          small
          @click="copyID(item.outer_transaction_id)"
        >
          content_copy
        </v-icon>
      </div>
    </td>
    <td>{{ item.statusString }}</td>
    <td>{{ item.bill }}</td>
    <td>{{ item.bank_name }}</td>
    <td>{{ item.amount }}</td>
    <td>
      <div
        v-if="appealCreateCondition(item)"
        style="display: flex; align-items: center; gap: 8px"
      >
        {{ getAppealStatus(item.appeal_status) }}

        <v-btn
          v-if="item.appeal_status === 3 || !item.appeal_status"
          fab
          style="width: 32px; height: 32px; margin-left: auto"
          color="secondary"
          @click="$router.push({
            path: `/users/${item.id}/appeal`,
            query: { new: true }
          })"
        >
          <v-icon
            small
          >
            add
          </v-icon>
        </v-btn>

        <v-btn
          v-else
          fab
          style="width: 32px; height: 32px; margin-left: auto"
          color="secondary"
          @click="$router.push({ path: `/users/${item.id}/appeal` })"
        >
          <v-icon
            small
          >
            edit
          </v-icon>
        </v-btn>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'UserTransactionsItem',
  props: {
    item: {
      id: '',
      operation: '',
      method: '',
      payway: '',
      outer_transaction_id: '',
      status: '',
      bill: '',
      bank_name: '',
      amount: '',
      appeal_status: ''
    }
  },
  methods: {
    appealCreateCondition (item) {
      return item.operation === 'Пополнение' && item.method !== 'admin_panel'
        && item.type === 'h2h' && item.payway
    },
    getAppealStatus (status) {
      if (status === 1)
        return 'Отклонено'
      if (status === 2)
        return 'Успешно'
      if (status === 3)
        return 'Ошибка'
      if (status === 4)
        return 'Отправлен'
    },
    shortWord (item) {
      if (item)
        return item.length > 10 ? `${item.slice(0, 10)}...` : item
    },
    copyID (id) {
      navigator.clipboard.writeText(id)
        .then(() => {
          this.$emit('copied')
        })
    }
  }
}
</script>

<style scoped>

</style>
